import { render, staticRenderFns } from "./PolicyImpact.vue?vue&type=template&id=59dd3e3c&"
import script from "./PolicyImpact.vue?vue&type=script&lang=js&"
export * from "./PolicyImpact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports